import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "~/lib/utils"

const switchVariants = cva("h-switch", {
  variants: {
    size: {
      xs: "h-switch--xs",
      sm: "h-switch--sm",
      md: "",
      lg: "h-switch--lg",
    },
  },
  defaultVariants: {
    size: "md",
  },
})

export interface SwitchProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size">,
    VariantProps<typeof switchVariants> {
  onCheckedChange?: (checked: boolean) => void
}

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  (
    {
      className,
      size,
      checked,
      defaultChecked,
      onCheckedChange,
      onChange,
      ...props
    },
    ref,
  ) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e)
      onCheckedChange?.(e.target.checked)
    }

    return (
      <input
        type="checkbox"
        role="switch"
        className={cn(switchVariants({ size, className }))}
        ref={ref}
        checked={checked}
        defaultChecked={defaultChecked}
        onChange={handleChange}
        {...props}
      />
    )
  },
)
Switch.displayName = "Switch"

export { Switch, switchVariants }
